<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "Index",
  inject: ['reload'],
  watch: {
    '$route.path': function (newVal, oldVal) {
      this.reload()
    }
  },
  data() {
    return {}
  },
  methods:{
    refresh(){
      this.reload()
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layout/index.vue